import { render, staticRenderFns } from "./basicInformation.vue?vue&type=template&id=5e767e98&scoped=true"
import script from "./basicInformation.vue?vue&type=script&lang=ts"
export * from "./basicInformation.vue?vue&type=script&lang=ts"
import style0 from "./basicInformation.vue?vue&type=style&index=0&id=5e767e98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e767e98",
  null
  
)

export default component.exports